import { FormItemProps } from '@/components/Form/types'
import getLaserProfiles from '@/services/ProductService/getLaserProfiles'


const items: Array<FormItemProps> = [

	{
		name: 'id',
		type: 'Hidden',
	},

	{
		name: 'hatch_type',
		label: 'Hatch Type',
		type: 'Select',
		itemOptions: {
			list: [
				{ label: 'Line Hatch', value: 'line' },
				{ label: 'Offset Fill Hatch', value: 'offset_fill' },
				{ label: 'Offset In/Out Hatch', value: 'offset_in_out' },
				{ label: 'Helix', value: 'helix' },
			],
		},
		classNames: { container: 'col-span-4 row-span-1' },
		defaultValue: { value: 'line' },
	},
	{
		name: 'hatch_style',
		label: 'Hatch Style',
		type: 'Select',
		itemOptions: {
			list: [
				{ label: 'Unidirectional', value: 'unidirectional' },
				{ label: 'Double Fill', value: 'double_fill' },
				{ label: 'Serpentine', value: 'serpentine' },
				{ label: 'Serpentine Connected', value: 'serpentine_connected' },
				{ label: 'Hatch 2 Times', value: 'hatch_2_times' },
				{ label: 'Hatch 3 Times', value: 'hatch_3_times' },
			],
		},
		classNames: { container: 'col-span-4 row-span-1' },
		defaultValue: { value: 'serpentine' },
		condition: (value) => value?.hatch_type?.value === 'line',
	},
	{
		name: 'laser_profile_id',
		label: 'Laser Profile',
		type: 'Select',
		itemOptions: {
			fetch: async () => {
				const list = await getLaserProfiles() || []
				return list.map((item) => ({
					data: item,
					label: item?.name,
					value: item?.id,
				}))
			},
		},
		classNames: { container: 'col-span-12 row-span-1' },
		defaultValue: null,
	},

	{
		name: 'border_gap',
		label: 'Border Gap',
		placeholder: 'Gap',
		type: 'Number',
		classNames: {
			container: 'col-span-4 ',
		},
		defaultValue: { value: '0' },
		condition: (value) => value?.hatch_type?.value === 'line',
	},
	{
		name: 'is_apply_smoothing',
		label: 'Apply Smoothing',
		type: 'Checkbox',
		classNames: {
			container: 'col-span-4 justify-end',
			content: 'h-[44px]',
		},
		defaultValue: true,
		//disabled: (value) => value.border_gap < 0.0000000001,
		condition: (value) => value?.hatch_type?.value === 'line',
	},
	{
		name: 'with_offset',
		label: 'With Offset',
		type: 'Checkbox',
		classNames: {
			container: 'col-span-4 justify-end',
			content: 'h-[44px]',
		},
		defaultValue: true,
		//disabled: (value) => value.border_gap < 0.0000000001,
		condition: (value) => value?.hatch_type?.value === 'line',
	},

	{
		name: 'border_gap_direction',
		label: 'Border Gap Direction',
		type: 'Select',
		itemOptions: {
			list: [
				{ label: 'Outward', value: 'outward' },
				{ label: 'Inward', value: 'inward' },
			],
		},
		classNames: { container: 'col-span-4 row-span-1' },
		defaultValue: { value: 'inward' },
		condition: (value) => value?.hatch_type?.value === 'line',
	},

	{
		name: 'corner_style',
		label: 'Corner Style',
		type: 'Select',
		itemOptions: {
			list: [
				{ label: 'Smooth', value: 'smooth' },
				{ label: 'Sharp', value: 'sharp' },
			],
		},
		classNames: { container: 'col-span-4 row-span-1' },
		defaultValue: { value: 'sharp' },
		condition: (value) => value?.hatch_type?.value === 'line',
	},

	{
		name: 'line_gap',
		label: 'Line Gap',
		placeholder: 'Gap',
		type: 'Number',
		classNames: { container: 'col-span-4 row-span-1' },
		defaultValue: '0.05',
		condition: (value) => value?.hatch_type?.value === 'line',
	},

	{
		name: 'line_angle',
		label: 'Line Angle',
		placeholder: 'Angle',
		type: 'Number',
		classNames: { container: 'col-span-4 row-span-1' },
		defaultValue: '90',
		condition: (value) => value?.hatch_type?.value === 'line',
	},
	{
		type: 'Divider',
		name: 'divider_1',
		classNames: { container: 'col-span-12' },
		condition: (value) => value?.hatch_type?.value === 'line',
	},
	{
		name: 'base_x',
		label: 'Base X',
		placeholder: 'X',
		type: 'Number',
		classNames: { container: 'col-span-4 row-span-1' },
		defaultValue: '0.0',
		condition: (value) => value?.hatch_type?.value === 'line',
	},
	{
		name: 'base_y',
		label: 'Base Y',
		placeholder: 'Y',
		type: 'Number',
		classNames: { container: 'col-span-4 row-span-1' },
		defaultValue: '0.0',
		condition: (value) => value?.hatch_type?.value === 'line',
	},
	{
		type: 'Divider',
		name: 'divider_2',
		classNames: { container: 'col-span-12 row-span-1' },
		condition: (value) => value?.hatch_type?.value === 'line',
	},
	{
		name: 'individual_hatch_line_repeat_count',
		label: 'Individual Hatch Line Repeat Count',
		placeholder: 'Count',
		defaultValue: '1',
		type: 'Number',
		classNames: { container: 'col-span-8 row-span-1' },
		condition: (value) => value?.hatch_type?.value === 'line',
	},
	{
		name: 'is_incremental_rotation_enabled',
		label: 'Incremental Rotation Enabled',
		type: 'Checkbox',
		classNames: {
			container: 'col-span-12 justify-end',
			content: 'h-[44px]',
		},
		defaultValue: false,
		condition: (value) => value?.hatch_type?.value === 'line',
	},

	{
		name: 'incremental_start_angle',
		label: 'Incremental Start angle',
		placeholder: 'Angle',
		type: 'Number',
		classNames: { container: 'col-span-4 row-span-1' },
		defaultValue: '0.0',
		condition: (value) => value?.hatch_type?.value === 'line',
	},
	{
		name: 'incremental_step_angle',
		label: 'Incremental Step angle',
		placeholder: 'Angle',
		type: 'Number',
		classNames: { container: 'col-span-4 row-span-1' },
		defaultValue: '0.0',
		condition: (value) => value?.hatch_type?.value === 'line',
	},
	{
		name: 'incremental_step_count',
		label: 'Incremental Step count',
		placeholder: 'Count',
		type: 'Number',
		classNames: { container: 'col-span-4 row-span-1' },
		defaultValue: 1,
		condition: (value) => value?.hatch_type?.value === 'line',
	},

]

export default items